<template lang="pug">
#project.row
  br
  br
  .col.s12
    .row.center
      p.Montserrat(style="font-size:70%") LOVE AND HATE SCORE AROUND {{$route.params.project.toUpperCase()}}
      .row.valign-wrapper#counterMain
        .col.s5
          p.Montserrat.smallestSize.rightT#love LOVE {{loveCount}}
        .col.s2
          img.loveMeter(src="../assets/love.png" v-bind:style="meterStyle")
        .col.s5
          p.Montserrat.smallestSize.leftT#hate HATE {{hateCount}}
      .row.smallSize.Montserrat#tweets
        .col.s1
        .col.s4.tweet(v-if="love.text")
          p.rightT
            b(style="color:white") {{love.user.name	}}
            |  @{{love.user.screen_name	}}
          p.rightT {{love.text}}
        .col.s2
          p <br><br><br><br><br>
        .col.s4.tweet(v-if="hate.text")
          p.leftT
            b(style="color:white") {{hate.user.name	}}
            |  @{{hate.user.screen_name	}}
          p.leftT {{hate.text}}
  .col.s12
    .row.valign-wrapper
      .col.s4
      .col.s4
        .col.s2
          a(href="#!" @click="prevPage(selectedMod)")
            i.material-icons chevron_left
        .col.s6
            select.browser-default(style="color:white;background: black;font-size: 70%;" v-model="selectedMod")
              option(value="positive" selected) Positive
              option(value="neutral") Neutral
              option(value="negative") Negative
        .col.s2
          p(style="color:#777; font-size:50%") page: {{pages[selectedMod]}}
        .col.s2
          a(href="#!" @click="nextPage(selectedMod)")
            i.material-icons chevron_right
      .col.s4
    .row#instagram.hScroll(v-if="instagram[selectedMod].length")
      instagram(v-for="i in getArrayPage(selectedMod)" v-if="instagram[selectedMod][i]" :i="instagram[selectedMod][i]" :key="instagram[selectedMod][i]._id")
    .row.hScroll(v-if="tweets[selectedMod].length")
      tweet(v-for="t in getArrayPage(selectedMod)" v-if="tweets[selectedMod][t]" :t="tweets[selectedMod][t]" :key="tweets[selectedMod][t]._id")
</template>

<script>
//var baseUrl = window.location.hostname == "localhost" ? "http://localhost:5500" : "";
var baseUrl = "https://loversnothaters.com";
import tweet from '@/components/tweet';
import instagram from '@/components/instagram';

export default {
  components:{
    tweet,
    instagram
  },
  data(){
    return {
      project: {},
      tweets: {positive:[], neutral:[], negative:[], users: [], count: {}},
      instagram: {positive:[], neutral:[], negative:[], users: [], count: {}},
      pages: {positive:0, neutral:0, negative:0, users: 0},
      total: {positive:0, neutral:0, negative:0, users: 0},
      selectedMod: "positive",
      love: {},
      hate: {},
      loveCount: 0,
      hateCount: 0,
      neutralCount: 0,
      lovePercent: 0,
      loveTime: 0,
      hateTime: 0,
      loveI: 0,
      hateI: 0,
      meterStyle:{
        background: ""
      }
    }
  },
  mounted(){
    this.getPositiveTweets(6);
    this.getNegativeTweets(6);
    this.getNeutralTweets(6);
    this.getUsers(6);
    this.getPositiveInstagram(6);
    this.getNegativeInstagram(6);
    this.getNeutralInstagram(6);
    setInterval(()=>{
      var loveRand = Math.floor(Math.random() * this.tweets.positive.length)
      this.love = this.tweets.positive[loveRand];
      var hateRand = Math.floor(Math.random() * this.tweets.positive.length)
      this.hate = this.tweets.negative[hateRand];
    }, 5000);
  },
  beforeUpdate(){
    var per = this.loveCount / (this.loveCount + this.hateCount) * 100;
    this.meterStyle.background = "-webkit-linear-gradient(-90deg, #00ffff 0%, #00ffff " + Math.floor(per) + "%, #AAA " + Math.floor(per) + "%, #AAA 100%)";
  },
  methods:{
    getPositiveTweets(limit, beforeId){
      console.log("Positive Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/posTweets/" + this.$route.params.project + "?limit=6" + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.tweets.count.positive = data.count;
        this.loveCount = data.count + this.instagram.count.positive;
        data.tweets.forEach((t)=>{
          this.tweets.positive.push(t);
        });
        if(this.tweets.positive[0]) this.love = this.tweets.positive[0];
        this.total.positive = data.count;
      });
    },
    getNegativeTweets(limit, beforeId){
      console.log("Negative Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/negTweets/" + this.$route.params.project + "?limit=6" + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.tweets.count.negative = data.count;
        this.hateCount = data.count + this.instagram.count.negative;
        data.tweets.forEach((t)=>{
          this.tweets.negative.push(t);
        });
        if(this.tweets.negative[0]) this.hate = this.tweets.negative[0];
        this.total.negative = data.count;
      });
    },
    getNeutralTweets(limit, beforeId){
      console.log("Neutral Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/neuTweets/" + this.$route.params.project + "?limit=6" + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.tweets.count.neutral = data.count;
        this.neutralCount = data.count + this.instagram.count.neutral;
        data.tweets.forEach((t)=>{
          this.tweets.neutral.push(t);
        });
        this.total.neutral = data.count;
      });
    },
    getUsers(limit, beforeI){
      if(!this.tweets.users.length){
        axios.get(baseUrl + "/projects/people/" + this.$route.params.project).then(({data})=>{
          this.tweets.users = data;
          this.total.users = data.count;
        });
      } else {

      }
    },
    getPositiveInstagram(limit, beforeId){
      console.log("Positive Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/posInstagram/" + this.$route.params.project + "?limit=" + (limit || 6) + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.instagram.count.positive = data.count;
        this.loveCount = data.count + this.tweets.count.positive;
        data.posts.forEach((p)=>{
          this.instagram.positive.push(p);
        });
      });
    },
    getNegativeInstagram(limit, beforeId){
      console.log("Negative Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/negInstagram/" + this.$route.params.project + "?limit=" + (limit || 6) + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.instagram.count.negative = data.count;
        this.hateCount = data.count + this.tweets.count.negative;
        this.hateCount += data.count;
        data.posts.forEach((p)=>{
          this.instagram.negative.push(p);
        });
        //this.total.negative = data.count;
      });
    },
    getNeutralInstagram(limit, beforeId){
      console.log("Neutral Load:", limit, beforeId);
      axios.get(baseUrl + "/projects/neuInstagram/" + this.$route.params.project + "?limit=" + (limit || 6) + (beforeId ? "&beforeId=" + beforeId : "")).then(({data})=>{
        this.instagram.count.neutral = data.count;
        this.neutralCount = data.count + this.tweets.count.neutral;
        data.posts.forEach((p)=>{
          this.instagram.neutral.push(p);
        });
        //this.total.neutral = data.count;
      });
    },
    getArrayPage(group){
      var r = [];
      for(var i=0; i<6; i++){
        r.push(this.pages[group]*6 + i);
      }
      return r;
    },
    nextPage(group){

      var funcs = {positive:this.getPositiveTweets, neutral:this.getNeutralTweets,
                   negative:this.getNegativeTweets, users: function(){}};
      var funcs2 = {positive:this.getPositiveInstagram, neutral:this.getNeutralInstagram,
                  negative:this.getNegativeInstagram, users: function(){}};
      if((this.pages[group]+1)*12  < this.instagram.count[group]  + this.tweets.count[group] ){
        console.log('im in')
        this.pages[group]++;
        if(this.tweets[group].length && this.tweets[group].length < this.pages[group] * 6 + 1)
          funcs[group](6, this.tweets[group][this.tweets[group].length-1].id_str);
        if(this.instagram[group].length && this.instagram[group].length < this.pages[group] * 6 + 1)
          funcs2[group](6, this.instagram[group][this.instagram[group].length-1].id);
      }
    },
    prevPage(group){
      if(this.pages[group] > 0){
        this.pages[group]--;
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#project
  background-color: black
  color: white
  min-height: 100vh
  padding-bottom: 0
  margin-bottom: 0
  font-size: 2vw
  width: 100vw
  background-color: black
  margin: 0px
  color: white
  padding-top: 20px
  p
    margin: 0
    line-height: 1.4
  .loveMeter
    width: 50%
  #counterMain
    padding-top: 10px
    font-weight: 200
  #love
    font-size: 110%
    font-weight: 300
    color: #00ffff
  #hate
    font-size: 110%
    font-weight: 300
    color: rgb(153,153,153)
  #tweets
    font-size: 60%
    font-weight: 400
    color: #CCCCCC
  .tweet
    position: relative
    top: -30px
.leftT
  position: relative
  text-align: left
  left: -2.5vw
.rightT
  position: relative
  text-align: right
  right: -2.5vw
.users
  min-height: 210px
  p
    line-height: 1 !important
.hScroll
  max-height: 720px
  overflow-x: auto
  overflow-y: hidden
  display: grid
  grid-template-columns: repeat(10, 300px)
  grid-gap: 10px
</style>



// WEBPACK FOOTER //
// src/components/project.vue